import { render, staticRenderFns } from "./ContactFormInfo.vue?vue&type=template&id=1b01eacc&scoped=true&"
import script from "./ContactFormInfo.vue?vue&type=script&lang=ts&"
export * from "./ContactFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ContactFormInfo.vue?vue&type=style&index=0&id=1b01eacc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b01eacc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VForm,VImg,VTooltip})
